import type { CropVarietyConfigurationsByKey } from "../types.js";

export const avocadoVarietyConfigurations = {
    "avocado.bacon": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.breda": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.carmen-hass": {
        crop: "avocado",
        aliases: ["Méndez", "Méndez No. 1"],
        isExample: false,
        customName: false,
    },
    "avocado.choquette": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.donnie": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.ettinger": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.fortuna": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.fuerte": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.geada": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.gem": { crop: "avocado", aliases: ["3-29-5"], isExample: false, customName: false },
    "avocado.gwen": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.hall": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.hass": { crop: "avocado", aliases: [], isExample: true, customName: false },
    "avocado.lamb-hass": { crop: "avocado", aliases: ["Lamb", "BL122"], isExample: false, customName: false },
    "avocado.lula": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.maluma": { crop: "avocado", aliases: ["Maluma Hass"], isExample: false, customName: false },
    "avocado.margarida": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.monroe": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.pinkerton": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.quintal": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.reed": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.simmonds": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.sir-prize": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.zutano": { crop: "avocado", aliases: [], isExample: false, customName: false },
    "avocado.custom": { crop: "avocado", aliases: [], isExample: false, customName: true },
} as const satisfies CropVarietyConfigurationsByKey;
